/**
 * Axios Request Wrapper
 * ---------------------
 */

import axios     from 'axios';
import constants from '../../shared/constants';

/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
  baseURL: constants.auth.baseUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS'
  }
});

// request interceptor
client.interceptors.request.use(config => {
  // Do something before request is sent
  var accessToken =  localStorage.getItem("auth_tokenKey")
  if (accessToken) {
    config.headers['Authorization'] = 'Bearer ' + accessToken
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

/**
 * Request Wrapper with default success/error actions
 */
const requestWrapper = async function(options) {
  var susscessTitleDefault = "Sucesso!";
  var successMessageDefault = "Operacao realizada com sucesso!";
  var successColorDefault = "success"

  var errorTitleDefault = "Erro!";
  var errorMessageDefault = "Erro ao efetuar a operacao!";
  var errorColorDefault = "danger"

  const onSuccess = function(response) {
    if(options.notifications != null && options.notifications.showSucces) {
      notify(successColorDefault, susscessTitleDefault, successMessageDefault)
    }
    
    return response;
  }

  const onError = function(error) {
    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      switch(error.response.status) {
        case 401:
            window.location.href = process.env.VUE_APP_URL_BASE + "/pages/mylogin";
            break;
        case 500:
            internalServerError500();
            break;
        case 400:
            badRequest400(error.response);
          break;
        default:
          break;
      }

      console.error('Status:',  error.response.status);
      console.error('Data:',    error.response.data);
      console.error('Headers:', error.response.headers);

      return error.response;
    } else {
      // Something else happened while setting up the request
      // triggered the error
      console.error('Error Message:', error.message);
    }

    return Promise.reject(error.response || error.message);
  }

  const badRequest400 = function(response)
  {
    if(options.notifications != null && options.notifications.showError) {
      console.log("badRequest400");
      console.log(options);

      if(response.data != null && response.data.errors != null)
      {
        options.notifications.errors = [];

        for (var key in response.data.errors) {

          console.log("key: ", key);
          console.log("error", response.data.errors[key][0]);

          var errorMessage = "";
          response.data.errors[key].forEach(element => {
            options.notifications.errors.push({
              [key]: element
            });

            errorMessage+= key + " - " + element;
          });

          alert(errorColorDefault, errorTitleDefault, errorMessage);
        }
      }
      else if(response.data != null && response.data.Message != '') {
        alert(errorColorDefault, errorTitleDefault, response.data.Message);
      } else {
        alert(errorColorDefault, errorTitleDefault, errorMessageDefault);
      }
    }
  }

  const internalServerError500 = function()
  {
    if(options.notifications != null && options.notifications.showError) {
      alert(errorColorDefault, errorTitleDefault, errorMessageDefault)
    }
  }

  const notify = function(color, title, message) {
    options.notifications.notify({
      color: color,
      title: title,
      text: message
    })
  }

  const alert = function(color, title, message) {
    options.notifications.dialog({
        color: color,
        title: title,
        text: message
    })
  }

  try {
        const response = await client(options);
        return onSuccess(response);
    }
    catch (error) {
        return onError(error);
    }
}

export default requestWrapper;